import React, { FC } from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import { MultiSelect } from 'primereact/multiselect';
import { createGlobalStyle } from 'styled-components';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
type MultiSelectProps = {
  value: any;
  options: any;
  optionLabel: any;
  onChange: any;
  placeholder: any;
  id: any;
  disabled: any;
};

const SelectMulti: FC<MultiSelectProps> = ({
  value,
  options,
  onChange,
  optionLabel,
  placeholder,
  disabled,
}) => {
  return (
    <Container className='sds-reset-style multiselect'>
      <Container className='card'>
        <Styles />
        <MultiSelect
          className='ecp-amonts'
          value={value}
          options={options}
          onChange={onChange}
          optionLabel={optionLabel}
          placeholder={placeholder}
          display='chip'
          disabled={disabled}
        />
      </Container>
    </Container>
  );
};
const Styles = createGlobalStyle`
.sds-reset-style{
  .pi{
    font-family: 'primeicons';
  }
.ecp-amonts{
    border-radius: 0px;
    background-color:#edf2fa;
    text-align: center;
    font-size: 14px;
    min-width: 117px;
    border-color: #edf2fa;;
    font-family: 'montserrat-italic';
    padding: 0px 4px;
    height: 10vh;
    .p-multiselect-token {
         margin-right: 8px;
         padding: 4px 8px;
     }
}
.p-multiselect .p-multiselect-trigger{
 color: #008BD2;
 width: 20px;
}
.p-multiselect-panel .p-multiselect-header .p-multiselect-close {
  width: 20px;
    height: 8px;
}
.p-multiselect .p-multiselect-label.p-placeholder {
    color: #232323;
    text-align: start;
    line-height: 39px;
    margin-top: 6px;
    padding-left: 10px;
    justify-content: center;
    height: 90%;
}
.p-multiselect-label {
         display: flex;
         flex-direction: column;
         border-radius: 2px;
         color: rgb(51, 51, 51);
         font-size: 85%;
         overflow: hidden;
         padding: 3px 3px 3px 6px;
         text-overflow: ellipsis;
         white-space: nowrap;
         box-sizing: border-box;
       }
}
`;

export default SelectMulti;
